/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {IDeadwoodRipData, ILowTransformData, IReplayNextPlayerInteraction} from "./IDeadwoodRipData";
import {DeadwoodRipDataParser} from "./DeadwoodRipDataParser";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";

export abstract class DeadwoodRipParsedData {

    public readonly mode:string;
    public readonly nextMode:string;
    public readonly reels:string[][];
    public readonly totalWin:number;
    public readonly multiplierOnReels:number[];
    public readonly currentMultiplier:number;
    public readonly S1Positions:number[];
    public readonly freespinsLeft:number;
    public readonly freespinTriggeredThisSpin:boolean;
    public readonly addedNumberOfFreespinsThisSpin:number;
    public readonly numberOfFreespinsPlayed:number;
    public readonly replayNextPlayerInteraction:IReplayNextPlayerInteraction | undefined;
    public readonly showTotalWin:boolean;
    public readonly lowTransformList:ILowTransformData[];
    public readonly S3Positions:number[];

    constructor(rawData:IDeadwoodRipData, parser:DeadwoodRipDataParser) {
        this.mode = rawData.mode;
        this.nextMode = rawData.nextMode;
        this.reels = parser.parseReels(rawData);
        this.totalWin = rawData.accumulatedRoundWin != null ? rawData.accumulatedRoundWin : 0;
        this.multiplierOnReels = rawData.multiplierOnReels.concat();
        this.currentMultiplier = rawData.mode === GameMode.NORMAL ? ArrayHelper.arraySum(this.multiplierOnReels) : rawData.multiplierFS;
        this.lowTransformList = rawData.lowTransformList.concat();

        this.S1Positions = parser.parseS1Positions(rawData);
        this.S3Positions = parser.parseS3Positions(rawData);

        this.freespinsLeft = rawData.freespinsLeft != null ? rawData.freespinsLeft : 0;
        this.freespinTriggeredThisSpin = rawData.freespinTriggeredThisSpin === true;
        this.addedNumberOfFreespinsThisSpin = rawData.addedNumberOfFreespinsThisSpin != null ? rawData.addedNumberOfFreespinsThisSpin : 0;
        this.numberOfFreespinsPlayed = rawData.numberOfFreespinsPlayed != null ? rawData.numberOfFreespinsPlayed : 0;
        this.replayNextPlayerInteraction = SlotGame.apiPlugin.isReplay ? rawData.nextPlayerInteraction : undefined;
        this.showTotalWin = this.parseShowTotalWin();

        // To add Avalanche Data
        // this.allWinPositions = rawData.allWinPositions.concat();
        // this.reelsAfterCollapse = rawData.reelsAfterCollapse.concat(); // TODO: if stacked symbol.
    }

    protected parseShowTotalWin():boolean {
        return this.isRespinMode(this.mode) || this.isRespinMode(this.nextMode) ||
            this.isFreespinMode(this.mode) || this.isFreespinMode(this.nextMode)

    }

    private isRespinMode(mode:string):boolean {
        return mode === GameMode.RESPIN;  // || mode === GameMode.NORMAL_AVALANCHE || mode === GameMode.FREESPIN_AVALANCHE
    }

    private isFreespinMode(mode:string):boolean {
        return mode === GameMode.FREESPIN || mode === GameMode.FREESPIN_SUPER;// || pick
    }
}